import { render, staticRenderFns } from "./grantImage.vue?vue&type=template&id=b4ce223a&scoped=true&"
import script from "./grantImage.vue?vue&type=script&lang=js&"
export * from "./grantImage.vue?vue&type=script&lang=js&"
import style0 from "./grantImage.vue?vue&type=style&index=0&id=b4ce223a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4ce223a",
  null
  
)

export default component.exports